import script from "./HeartrateModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeartrateModule.vue?vue&type=script&setup=true&lang=ts"

import "./HeartrateModule.vue?vue&type=style&index=0&id=3b399325&lang=scss"

const __exports__ = script;

export default __exports__